











import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Icon from '../../src/components/Icon.vue';

@Component({
  components: {Icon}
})
export default class Button extends Vue {
  @Prop(String) icon?: string;
  @Prop({
    type: String, default: 'left',
    validator(value: string): boolean {return value === 'left' || value === 'right';}
  })
  iconPosition?: string;
  @Prop({type: Boolean, default: false}) loading?: boolean;
}
